<template>
  <a-select
    allow-clear
    show-search
    :value="value"
    :multiple="multiple"
    :placeholder="placeholder"
    option-filter-prop="title"
    @change="onChange"
    @clear="onClear"
    :class="class"
  >
    <a-select-option
      v-for="item in data?.records"
      :key="item.id"
      :value="item.id"
      :title="item.realName"
    >
      {{ item.realName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import { SalesManService } from "./sales-man.service";
import { UserSimpleListReq } from "./sales-man.interface";
/**
 * 业务员选择器
 * <sales-man-select v-model:value="formRef.salesManId"></sales-man-select>
 */
export default defineComponent({
  name: "SalesManSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    activatedStatus: {
      type: Number,
      default: undefined,
    },
    status: {
      type: Number,
      default: undefined,
    },
    onJob: {
      type: Boolean,
      default: undefined,
    },
    staffType: {
      type: String,
      default: 'no_type',
    },
    class: {
      type: String,
      default: "append-to-parent",
    },
  },
  emits: ["update:value"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = SalesManService.useSimpleListApi();
    let params = reactive(new UserSimpleListReq());
    const onChange = (id) => {
      emit("update:value", id);
    };

    const onClear = () => {
      emit("update:value", undefined);
    };

    onMounted(async () => {
      params.activatedStatus = 1;
      params.status = 1;
      params.onJob = true;
      params.staffType = props.staffType;
      
      await run(params);
    });

    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
